import { render, staticRenderFns } from "./text-button.vue?vue&type=template&id=75c21bd9"
import script from "./text-button.vue?vue&type=script&lang=ts"
export * from "./text-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports